var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimIconB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 6.52449V12.0003C17.3334 12.4424 17.1578 12.8663 16.8453 13.1788C16.5327 13.4914 16.1088 13.667 15.6667 13.667H4.83341C4.39139 13.667 3.96746 13.4914 3.6549 13.1788C3.34234 12.8663 3.16675 12.4424 3.16675 12.0003V10.7503M17.3334 6.52449V5.33366C17.3334 4.89163 17.1578 4.46771 16.8453 4.15515C16.5327 3.84259 16.1088 3.66699 15.6667 3.66699H14.8334M17.3334 6.52449H14.8334",
    stroke: "#02A0FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8334 3.66667V9.08333C14.8334 9.52536 14.6578 9.94928 14.3453 10.2618C14.0327 10.5744 13.6088 10.75 13.1667 10.75H2.33341C1.89139 10.75 1.46746 10.5744 1.1549 10.2618C0.842343 9.94928 0.666748 9.52536 0.666748 9.08333V2.41667C0.666748 1.97464 0.842343 1.55072 1.1549 1.23816C1.46746 0.925595 1.89139 0.75 2.33341 0.75H13.1667C13.6088 0.75 14.0327 0.925595 14.3453 1.23816C14.6578 1.55072 14.8334 1.97464 14.8334 2.41667V3.66667ZM14.8334 3.66667H3.58341",
    stroke: "#02A0FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimIconB);
export default __webpack_public_path__ + "static/media/ClaimIconB.429889f5f6af84650bd91b333f479e9f.svg";
export { ForwardRef as ReactComponent };